exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activityblock[data-v-1f41465f]{height:38px}.activityblockmobile[data-v-1f41465f]{height:68px !important}.lightred[data-v-1f41465f]{background-color:#ff8a80}.red[data-v-1f41465f]{background-color:#ff0000}\n", ""]);

// exports
